var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1201 2339 c-94 -16 -178 -64 -261 -148 -123 -125 -179 -258 -188 -446 -6 -144 13 -240 72 -360 53 -107 118 -184 200 -237 303 -195 672 -8 767 388 42 174 13 382 -73 532 -39 69 -126 162 -187 202 -97 61 -222 88 -330 69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719 947 c-144 -64 -263 -148 -356 -252 -68 -76 -129 -173 -144 -230 -23 -83 26 -178 117 -225 l48 -25 865 -3 c593 -2 882 1 917 8 129 27 210 154 171 268 -40 116 -190 290 -325 377 -193 124 -295 144 -413 81 -202 -107 -430 -109 -631 -4 -89 46 -154 48 -249 5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.76fd63d0f5c492b723c7b2b3817a8781.svg";
export { ForwardRef as ReactComponent };